import { useState } from 'react'
import Modal from '../../../../components/modal/Modal'
import { Icon } from '@iconify/react'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import FormLoader from '../../../../components/loader/FormLoader'

function CreateAdmin({ fetchAdmins, setShowCreateAdmin }: any) {
  const { notify } = useGlobalContext()
  const [nameInput, setNameInput] = useState('')
  const [role, setRole] = useState('')
  const [emailInput, setEmailInput] = useState('')
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false)

  const createAdmin = async () => {
    const emptyFields = []
    if (!nameInput) emptyFields.push('Name')
    if (!role) emptyFields.push('Role')
    if (!emailInput) emptyFields.push('Email')
    if (!phone) emptyFields.push('Phone')
    if (emptyFields.length > 0) {
      notify(
        'warn',
        `The following fields are required: ${emptyFields.join(', ')}`
      )
      return
    }

    const data = {
      name: nameInput,
      role,
      email: emailInput.toLowerCase(),
      phone: phone,
    }
    setLoading(true)
    post(`admin/create`, data, null)
      .then((result: any) => {
        if (result.status === 201) {
          notify('success', result.message)
          setShowCreateAdmin(false)
          fetchAdmins(1)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <Modal>
      <div className='left-modal'>
        <div className='modal-top flex justify-between items-center'>
          <h2>Create Admin</h2>
          <div className='close flex items-center justify-center'>
            <Icon
              icon='line-md:close'
              onClick={() => setShowCreateAdmin(false)}
            />
          </div>
        </div>
        <div className='form'>
          <div className='input-card'>
            <p>Name</p>
            <input type='text' onChange={(e) => setNameInput(e.target.value)} />
          </div>
          <div className='input-card'>
            <p>Role</p>
            <select
              name=''
              id=''
              onChange={(e) => setRole(e.target.value)}
              value={role}
            >
              <option value=''>-Select-</option>
              <option value='agent'>Agent</option>
              <option value='customer service'>Customer Service</option>
              <option value='manager'>Manager</option>
              <option value='super admin'>Super Admin</option>
            </select>
          </div>
          <div className='input-card'>
            <p>Email</p>
            <input
              type='email'
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
            />
          </div>
          <div className='input-card'>
            <p>Phone</p>
            <input
              type='tel'
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className='input-card'>
            {loading ? (
              <FormLoader position='center' />
            ) : (
              <button onClick={createAdmin}>Create</button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CreateAdmin
